module.exports = {"required":"Pole jest wymagane","incorrect":"Wprowadzone dane nie są poprawne","lastNameVerification":"Nazwisko jest niezgodne z wzorem"}